<template>
    <div class="xsbmCls" v-loading="xsbmLoading">
        <div>
			<div class="mk-title-container">
				<img src="../../assets/img/02xuesheng.png" />学生选择
			</div>
            <el-input v-model="xueyuanMc" clearable placeholder="学员、学员编码、联系电话、学生端手机号"
                style="width: 400px;margin-right: 10px;"></el-input>
            <el-button @click="searchClk" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="addClk" icon="el-icon-plus">新增学生</el-button>
        </div>
        <div class="tjxx">
			<template v-if="xsList.length > 0">
				<div class="header-block">
					<div style="width: 8%;">序号</div>
					<div style="width: 15%;">学生编码</div>
					<div style="width: 15%;">学生姓名</div>
					<div style="width: 15%;">学生英文名</div>
					<div style="width: 15%;">性别</div>
					<div style="width: 15%;">联系电话</div>
					<div style="width: 15%;">学生端手机号</div>
				</div>
				<div class="list-container">
					<div class="listData"
						v-for="(item, index) in xsList"
						:key="item.id"
						@click="checkClk(item, index)"
						:style="(index == checkIndex)?'border: 1px solid #18CE58;':''">
						<span v-if="index == checkIndex" class="el-icon-success"></span>
						<div style="width: 8%;"><span v-if="index<=9">0</span>{{ index + 1 }}</div>
						<div style="width: 15%;">{{ item.xueyuanBm }}</div>
						<div style="width: 15%;">{{ item.xueyuanMc }}</div>
						<div style="width: 15%;">{{ item.xueyuanYwmc }}</div>
						<div style="width: 15%;">
					        <template v-if="item.xb == 0">男</template>
					        <template v-if="item.xb == 1">女</template>
						</div>
						<div style="width: 15%;">{{ item.lxdh }}</div>
						<div style="width: 15%;">{{ item.sjh }}</div>
					</div>
				</div>
			</template>
			<div class="no-data" v-if="xsList.length === 0">
				<img src="../../assets/img/zanwu_baise3.png"/>
				<p>暂无学员</p>
			</div>
        </div>
        <div style="margin: 20px 0;">
			<div class="mk-title-container">
				<img src="../../assets/img/02banji.png" />班级选择
			</div>
            <el-input v-model="bjmc" clearable placeholder="请输入班级名称" style="width: 200px;margin-right: 10px;"></el-input>
            <el-select v-model="ywcode" clearable placeholder="请选择业务" style="width: 150px;margin-right: 10px;">
                <el-option v-for="(item,index) in ywList" :key="index" :label="item.ywmc" :value="item.ywcode"></el-option>
            </el-select>
            <!-- <el-select v-model="bhhbjb" :popper-append-to-body="false" filterable placeholder="包含绘本级别" clearable>
                <el-option value="0" label="1">1</el-option>
                <el-option value="1" label="2">2</el-option>
            </el-select> -->
            <el-button @click="queryBmjlList" icon="el-icon-search">查询</el-button>
        </div>
        <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" height="300px" v-loading="loading" class="zdy-table">
            <el-table-column label="序号" width="70">
				<template slot-scope="scope">
				  <span v-if="scope.$index<=9">0</span>{{ scope.$index+1 }}
				</template>
			</el-table-column>
            <el-table-column prop="bjmc" label="班级名称" width="150">
            </el-table-column>
            <el-table-column prop="ywmc" label="业务名称" width="120">
            </el-table-column>
            <el-table-column align="center" width="150" label="学生数">
              <template slot-scope="scope">
                {{ scope.row.xsrs }} / {{ scope.row.bjrs }}
              </template>
            </el-table-column>
            <el-table-column prop="hbjb" label="包含绘本级别">
            </el-table-column>
            <el-table-column prop="jsmc" label="教师" width="150">
            </el-table-column>
            <el-table-column align="center" width="150" label="开班时间">
                <template slot-scope="scope">
                    {{ formatDate(new Date(scope.row.kbsj), 'yyyy-MM-dd') }}
                </template>
            </el-table-column>
            <el-table-column align="center" width="150" label="结课时间">
                <template slot-scope="scope">
                    {{ formatDate(new Date(scope.row.jksj), 'yyyy-MM-dd') }}
                </template>
            </el-table-column>
			<el-table-column label="操作" width="100" align="center">
			    <template slot-scope="scope">
			        <el-button type="text" @click="bmClk(scope.row)">报名</el-button>
			    </template>
			</el-table-column>
        </el-table>
        <!-- 新增 -->
        <el-dialog title="新增学生" :visible.sync="dialogVisible" width="30%" @close="handleClose('ruleForm')"
            v-loading="diaLoading" :close-on-click-modal="false">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
<!--                <el-form-item label="学生编码" prop="xueyuanBm">
                    <el-input v-model="ruleForm.xueyuanBm" clearable placeholder="请输入学生编码"></el-input>
                </el-form-item>-->
                <el-form-item label="学生姓名" prop="xueyuanMc">
                    <el-input v-model="ruleForm.xueyuanMc" clearable placeholder="请输入学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="学生英文名">
                    <el-input v-model="ruleForm.xueyuanYwmc" clearable placeholder="请输入学生英文名"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="xb">
                    <el-radio-group v-model="ruleForm.xb">
                        <el-radio :label="0">男</el-radio>
                        <el-radio :label="1">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="联系电话" prop="lxdh">
                    <el-input v-model="ruleForm.lxdh" clearable placeholder="请输入联系电话"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" @click="bmcnkcSave('ruleForm')">报名常年课程</el-button>
                <el-button type="primary" @click="bmdqbSave('ruleForm')">报名短期班</el-button> -->
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="xsglSave('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 报名 -->
        <el-dialog title="报名确认" :visible.sync="dialogVisibleBm" width="500px" :close-on-click-modal="false">
            <div class="bmxqCls">
                <div class="title">学生信息</div>
                <div class="xqxx">
                    <div>
                        <label for="">学生编码：</label>
                        {{ xsObj.xueyuanBm }}</div>
                    <div>
                        <label for="">学生姓名：</label>
                        {{ xsObj.xueyuanMc }}</div>
                    <div>
                        <label for="">学生英文名：</label>
                        {{ xsObj.xueyuanYwmc }}</div>
                    <div>
                        <label for="">学生性别：</label>
                        <template v-if="xsObj.xb == 0">男</template>
                        <template v-if="xsObj.xb == 1">女</template>
                    </div>
                    <div>
                        <label for="">联系电话：</label>
                        {{ xsObj.lxdh }}
                    </div>
                </div>
            </div>
            <div class="bmxqCls" style="margin-top: 20px;">
                <div class="title">班级信息</div>
                <div class="xqxx xqxx2">
                    <div>
                        <label for="">班级名称：</label>
                        {{ bjObj.bjmc }}</div>
                    <div>
                        <label for="">包含绘本级别：</label>
                        {{ bjObj.hbjb }}</div>
                    <div>
                        <label for="">教师：</label>
                        {{ bjObj.jsmc }}</div>
                    <div>
                        <label for="">开班时间：</label>
                        {{ formatDate(new Date(bjObj.kbsj), 'yyyy-MM-dd') }}</div>
                    <div>
                        <label for="">结课时间：</label>
                        {{ formatDate(new Date(bjObj.jksj), 'yyyy-MM-dd') }}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleBm = false">取消</el-button>
                <el-button type="primary" @click="bmSaveClk">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// import CityList from '../../assets/js/city';
export default {
    name: 'xsbmPage',
    data() {
        return {
            xsxm: '',
            bjmc: '',
            ywcode: '',
            ywList: [],
            bhhbjb: '',
            tableData: [],
            dialogVisible: false,
            dialogVisibleBm: false,

            ruleForm: {
                xb: 0
            },
            rules: {
                /*xueyuanBm: [
                    { required: true, message: '请输入学生编码', trigger: 'blur' }
                ],*/
                xueyuanMc: [
                    { required: true, message: '请输入学生姓名', trigger: 'blur' }
                ],
                xb: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                lxdh: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的联系电话', trigger: 'blur' }
                ],
            },
            jgglId: sessionStorage.getItem("jgglId"),
            xueyuanMc: '',
            xsList: [],
            loading: false,
            xsObj: {},
            bjObj: {},
            checkIndex: null,
            shengList: [],
            shiList: [],
            quList: [],
            diaLoading: false,
			xsbmLoading: false
        }
    },
    created() {
        let _this = this;
        _this.findJgYwList();
        _this.queryBmjlList();
        // // 加载省份数据
        // CityList.forEach((item, index) => {
        //     //省级数据
        //     _this.shengList.push({ id: item.code, value: item.name, children: item.city })
        // })
    },
    methods: {
        searchClk() {
            if (!this.xueyuanMc) {
                this.$message.info('学生姓名、学号、联系电话不能为空');
                return;
            }
			this.xsbmLoading = true;
            this.queryXsList();
            this.checkIndex = null;
        },
        // 新增/编辑
        xsglSave(ruleForm) {
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    this.diaLoading = true;
                    this.$post("xueyuan/XueyuanController/xueyuanSave", { ...this.ruleForm, jgglId: this.jgglId }, "json").then(res => {
                        this.diaLoading = false;
                        if (res.code == 1) {
                            this.$message({
                                type: "success",
                                message: res.msg
                            });
                            this.dialogVisible = false;
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                    })
                }
            })
        },
        // // 省份改变时
        // shengChange(val) {
        //     this.ruleForm.shi = '';
        //     this.ruleForm.qu = '';
        //     this.shiList = [];
        //     // 市级数据
        //     this.shengList.forEach(item => {
        //         if (item.id == val) {
        //             item.children.forEach(item2 => {
        //                 this.shiList.push({ id: item2.code, value: item2.name, children: item2.area });
        //             });
        //         }
        //     })

        // },
        // // 市改变时
        // shiChange(val) {
        //     this.ruleForm.qu = '';
        //     this.quList = [];
        //     // 区级数据
        //     this.shiList.forEach(item => {
        //         if (item.id == val) {
        //             item.children.forEach(item2 => {
        //                 this.quList.push({ id: item2.code, value: item2.name, children: [] });
        //             });
        //         }
        //     })
        // },
        // // 区改变时
        // quChange(val) { },
        // 选中学生
        checkClk(item, index) {
			if(this.checkIndex === index){
				this.checkIndex = null;
			}else{
				this.checkIndex = index;
				this.xsObj = item;
			}
        },
        // 点击报名
        bmClk(item) {
            if (!this.checkIndex && this.checkIndex != 0) {
                this.$message.info('请选择学生进行报名');
                return;
            }
            this.bjObj = item;
            this.dialogVisibleBm = true;
        },
        // 关闭新增弹窗时
        handleClose(ruleForm) {
            this.ruleForm = {};
            this.$refs[ruleForm].resetFields();
        },
        // // 报名常年课程
        // bmcnkcSave(ruleForm) {
        //     this.$refs[ruleForm].validate((valid) => {
        //         if (valid) {

        //         }
        //     })
        // },
        // // 报名短期班
        // bmdqbSave(ruleForm) {
        //     this.$refs[ruleForm].validate((valid) => {
        //         if (valid) {

        //         }
        //     })
        // },
        // 新增
        addClk() {
            this.dialogVisible = true;
        },
        // 报名确认
        bmSaveClk() {
            let data = {
                "bjglId": this.bjObj.id,
                "bjmc": this.bjObj.bjmc,
                "lxdh": this.xsObj.lxdh,
                "xueyuanBm": this.xsObj.xueyuanBm,
                "xueyuanId": this.xsObj.id,
                "xueyuanMc": this.xsObj.xueyuanMc
            }
            this.$post("xueyuan/XueyuanController/xueyuanBaoming", data, 'json').then(res => {
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: '报名成功'
                    });
                    this.dialogVisibleBm = false;
                    this.queryBmjlList()
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            })
        },
        // 获取学生列表
        queryXsList() {
            this.$post("xueyuan/XueyuanController/xueyuanList", { jgglId: this.jgglId, xueyuanMc: this.xueyuanMc }).then(res => {
                if (res.code == 1) {
                    this.xsList = res.result.list;
					this.xsbmLoading = false;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            })
        },
        // 获取报名记录列表
        queryBmjlList() {
            this.loading = true;
            this.$post("bjgl/BjglController/bjglList", { jgglId: this.jgglId, bjmc: this.bjmc, ywcode: this.ywcode, zts: '0,1' }).then(res => {
                this.loading = false;
                if (res.code == 1) {
                    this.tableData = res.result.list;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            })
        },
        findJgYwList(){
            var _this = this;
            _this.$post('bjgl/JgglController/findJgglYwListByJgglId', {jgglId: _this.jgglId}).then((rep) => {
                if (rep.code == 1) {
                    _this.ywList = rep.result.ywList;
                } else {
                    _this.$message({
                        type: "error",
                        message: rep.msg
                    });
                }
            })
        },
    }
}
</script>

<style scoped>
.jzdzCls>>>.el-form-item__content {
    margin-left: 10px !important;
}
</style>
<style>
	.zdy-table th.el-table__cell{
		background: #ECECEC;
	}
	.zdy-table .el-table__cell{
		padding: 6px 0;
	}
</style>
<style lang="less" scoped>
.xsbmCls {
	.mk-title-container{
		display: inline-block;
		margin-right: 18px;
		font-size: 16px;
		font-weight: 500;
		img{
			width: 21px;
			height: 26px;
			vertical-align: middle;
			margin-bottom: 4px;
			margin-right: 9px;
		}
	}
    .tjxx {
        border-bottom: 1px solid #EBEEF5;
        padding: 20px 0;
		height: 300px;
		.header-block{
			background: #E1F5FE;
			text-align: center;
			font-size: 14px;
			color: #333333;
			padding: 8px 0;
			border-radius: 4px;
			div{display: inline-block};
		}
		.list-container{
			height: 220px;
			overflow: auto;
			margin-top: 10px;
		}
        .listData {
			position: relative;
            padding: 10px 0px;
            border-radius: 5px;
			box-shadow: 0px 1px 6px 0px rgba(3,20,47,0.13);
			border: 1px solid #DCDFE6;
            cursor: pointer;
            margin-top: 10px;
			text-align: center;
			font-size: 14px;
			color: #333333;
            div {
                display: inline-block;
            }
			.el-icon-success{
				color: #18CE58;
				position: absolute;
				left: 2.2%;
				top: 11px;
				font-size: 18px;
			}
        }

        .listData:first-child {
            margin-top: 0;
        }
    }

    /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
    .tjxx::-webkit-scrollbar {
      display: none;
    }

    /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
    .tjxx {
      -ms-overflow-style: none;  /* IE 和 Edge */
      scrollbar-width: none;  /* Firefox */
    }
	.zdy-table{
		border: 1px solid #EBEEF5;
		border-radius: 5px;
	}
    .addCls {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-right: 30px;

        .el-form-item {
            width: 48%;

            .el-select,
            .el-date-editor {
                width: 100%;
            }
        }
    }

    .bmxqCls {
        .title {
            font-size: 16px;
        }

        .xqxx {
            background-color: #cfcfcf;
            border-radius: 5px;
            padding: 10px;
            margin-top: 10px;
            display: flex;
            flex-direction: column;

            div {
                margin-bottom: 5px;
                label{
                    display: inline-block;
                    width: 90px;
                    text-align: right;
                }
            }
        }
        .xqxx2{
            div{
                label{
                    width: 100px;
                }
            }
        }
    }
}
</style>